import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";

export default function AdminLoginPage() {
  const { t } = useLang();
  const { login, user, checking } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (!checking && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-radial-gold grid place-items-center px-4">
      <div className="w-full max-w-md card-dark p-8 sm:p-10 gold-glow" data-testid="admin-login-card">
        <div className="text-center mb-8">
          <img
            src="/logo.png"
            alt="Eazy-Travels"
            className="h-14 w-auto object-contain mx-auto mb-5 drop-shadow-[0_0_30px_rgba(244,196,48,0.35)]"
          />
          <h1 className="font-display text-2xl font-bold text-white mb-1">{t("admin.login")}</h1>
          <p className="text-sm text-white/55">Eazy-Travels Admin</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest text-white/55 mb-1.5 block">{t("admin.email")}</label>
            <div className="relative">
              <Mail size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[var(--gold)]" />
              <input
                required
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-dark pl-10"
                data-testid="admin-email-input"
              />
            </div>
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-white/55 mb-1.5 block">{t("admin.password")}</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[var(--gold)]" />
              <input
                required
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-dark pl-10"
                data-testid="admin-password-input"
              />
            </div>
          </div>
          <button type="submit" disabled={submitting} className="btn-gold w-full justify-center" data-testid="admin-login-submit">
            {submitting && <Loader2 size={16} className="animate-spin" />}
            {t("admin.signin")}
          </button>
        </form>
      </div>
    </div>
  );
}
